var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcArrowLeft = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42586E",
    fillRule: "evenodd",
    d: "M15.833 9.167H5.946l3.027-3.634c.295-.353.247-.879-.107-1.173-.354-.295-.879-.247-1.173.107l-4.167 5c-.032.039-.049.085-.073.128-.02.035-.044.065-.06.103-.037.096-.06.197-.06.299v.006c0 .102.023.203.06.299.016.038.04.068.06.103.024.043.04.09.073.128l4.167 5c.165.198.402.3.64.3.188 0 .378-.063.533-.193.354-.294.402-.82.107-1.173l-3.027-3.634h9.887c.46 0 .833-.373.833-.833 0-.46-.373-.833-.833-.833z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcArrowLeft, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_arrow-left.ecffb905.svg";
export { ForwardRef as ReactComponent };